export type CtaButtonSize = 'small' | 'medium' | 'large';

export interface CtaContentProps {
  showArrow?: boolean;
  size?: CtaButtonSize;
  text?: string;
}

export function ctaButtonLeading(size?: CtaButtonSize): string {
  return size === 'large' ? 'leading-[26px]' : size === 'medium' ? 'leading-6' : '';
}

export function ctaButtonTextSize(size?: CtaButtonSize): string {
  return size === 'small' ? '' : 'text-xl';
}

export function ctaButtonSize(size?: CtaButtonSize): string {
  return size === 'small' ? 'btn-lg' : 'btn-xlg';
}

export default function CtaContent({
  text = 'Start your free journal now',
  size = 'medium',
  showArrow = true,
}: CtaContentProps) {
  if (showArrow) {
    return (
      <>
        {text}{' '}
        <span
          className={`tracking-normal ${ctaButtonLeading(size)} ${ctaButtonTextSize(
            size
          )} text-blue-300 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1 hidden md:inline-block`}
        >
          -&gt;
        </span>
      </>
    );
  }

  return <span>{text}!</span>;
}
